import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de compteur des msg
 */
@Injectable()
export class MsgcountService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/msgcount";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de compteur des msg
   */
  public proc_getHBMsgCount(id: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getmsgcount/${id}`,
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/msgcount.service.ts